export const config = {
    increment: 10,
    decrement: 0,
    true: 'Doen',
    false: 'Niet doen'
}



// WEBPACK FOOTER //
// ./src/data/config.js